import pure from "./higher-order/pure";
import LightBox from "./light-box";
import LightBoxBody from "./light-box-body";
import LightBoxFooter from "./light-box-footer";
import React from "react";

export default pure(function ConfirmBox({ children, confirmMessage = "Confirm", onCancel, onConfirm }) {
  return (
    <LightBox
      onClose={onCancel} title={
        <span key="2">
          <i className="dw-warning5 dw--baseline" />

          {" "}
          Confirmation
        </span>
      }>
      <LightBoxBody>
        {children}
      </LightBoxBody>

      <LightBoxFooter>
        <button className="btn" onClick={onCancel} type="button">
          Cancel
        </button>

        <button className="btn btn--primary" onClick={onConfirm} type="button">
          {confirmMessage}
        </button>
      </LightBoxFooter>
    </LightBox>
  );
});
